module.exports = __webpack_public_path__ + "static/media/implant.7b1b98b5.jpg";